import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginCallbackComponent } from './login-callback/login-callback.component';

@NgModule({
    declarations: [LoginComponent, LogoutComponent, LoginCallbackComponent],
    imports: [CommonModule, RouterModule],
    providers: []
})
export class AuthenticationModule {}
